export const YOULL_NEVER_BE_THE_PERFECT_APPLICANT_CONTENT_MARKUP: string = `# You'll Never Be the Perfect Applicant (Apply Anyway!)

## Three Fun Facts About Me:
- I've been a professional developer for 10+ years.
- I've worked at 5 different companies (ranging from 10-person startups to FAANG).
- I've never been "qualified" for a job I was hired for.

---

## What Do I Mean?

I’m not saying I tricked anyone into hiring me. Rather, if I look back at each job posting’s "requirements" versus my skills at the time, I was never a perfect match.

One of the biggest issues I see with new developers is their inclination to reject themselves before they even apply for a job. They’ll see postings that list:

- 3 years experience
- Experience with random_react_Library_1
- Experience with random_react_Library_2

They’ll think: “Well, I only have 1.5 years of experience and I only know library #1. Guess I’m out.” And they don’t apply.

---

## How Job Postings Really Work

A job listing usually describes the **perfect candidate**—someone with the right number of years, the exact tools, the ideal background. In reality, that perfect candidate rarely applies or may not even exist. Companies often hire someone who has a good chunk of the requirements and shows a willingness to learn the rest.

Instead of rejecting yourself on the company’s behalf, submit your application. Let them decide if you’re missing something critical.

---

## A Few Caveats:

### 1. Be Realistic

I’m not saying to go wild and apply for senior machine learning roles if you’re a junior frontend dev. If a company is looking for a web developer and you match about **50–70% of the posting**, go for it. That’s a realistic gamble worth taking.

### 2. Become More of The Candidate They Want

You might match 60% of the requirements for a job and land an interview a week later. That’s a solid heads-up: you’ve got a description of their “perfect candidate.” Spend the days before your interview filling gaps in your knowledge. You don’t need to become an expert in Flask or Retrofit overnight, but at least learn the basics.

If they ask, “Have you used Flask before?” consider these two answers:

**Answer A:** “No, I’ve never used it.”  
**Answer B:** “No, I haven’t used it in a project yet, but I understand it’s a popular Python library for building APIs. My experience so far has been with pre-built APIs, but I’ve been excited to learn Flask.”

Which do you think sounds better?

### 3. Find Commonalities in Listings

While you’re applying, pay attention to recurring skills you lack. If you see “Jetpack Compose” in 9 out of 10 Android job postings, that’s a hint. Spend your downtime learning Jetpack Compose. Job searching can take a long time, so use that time to keep improving your chances as a candidate.

---

## Conclusion

If you’ve been holding back on applying for jobs because you’re not a 100% match, go for it anyway. Let the company decide if you’re a fit—you might be surprised by the outcome.

And best of luck on your job search!
`;